<small class="text-danger" *ngIf="showErrors()">
  <p>
      <span *ngIf="control.errors && control.errors.required"> Das Feld muss ausgefüllt sein.<br></span>
      <span *ngIf="control.errors && control.errors.minlength"> Die Eingabe ist zu kurz.<br></span>
      <span *ngIf="control.errors && control.errors.dateInPast"> Das Datum muss in der Zukunft liegen.<br></span>
      <span *ngIf="control.errors && control.errors.pattern"> Bitte geben Sie ein valides Format ein.<br></span>
      <span *ngFor="let error of getErrors()">{{error}}<br></span>
  </p>
</small>
